<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="会员ID：" prop="member_id">
                <el-input v-model="model.member_id"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <el-input v-model="model.email"></el-input>
            </el-form-item>
            <el-form-item label="车表ID：" prop="car_info_id">
                <el-input v-model="model.car_info_id"></el-input>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <el-input v-model="model.car_id"></el-input>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <el-input v-model="model.vehicle_id"></el-input>
            </el-form-item>
            <el-form-item label="行驶次数：" prop="drive_count">
                <el-input v-model="model.drive_count"></el-input>
            </el-form-item>
            <el-form-item label="行驶里程：" prop="mileage">
                <el-input v-model="model.mileage"></el-input>
            </el-form-item>
            <el-form-item label="平均速度：" prop="avg_speed">
                <el-input v-model="model.avg_speed"></el-input>
            </el-form-item>
            <el-form-item label="平均能耗：" prop="avg_enc">
                <el-input v-model="model.avg_enc"></el-input>
            </el-form-item>
            <el-form-item label="充电次数：" prop="charge_count">
                <el-input v-model="model.charge_count"></el-input>
            </el-form-item>
            <el-form-item label="充入电量：" prop="charge_in">
                <el-input v-model="model.charge_in"></el-input>
            </el-form-item>
            <el-form-item label="时间：" prop="add_time">
                <el-input v-model="model.add_time"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'carDailyEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                car_info_id: '',
                car_id: '',
                vehicle_id: '',
                drive_count: '',
                mileage: '',
                avg_speed: '',
                avg_enc: '',
                charge_count: '',
                charge_in: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/cardaily/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/cardaily/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>